import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-bg',
  templateUrl: './home-bg.component.html',
  styleUrls: ['./home-bg.component.scss']
})
export class HomeBgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
